var componentRequireContext = require.context("bundles/ui", true);
var ReactRailsUJS = require("react_ujs");
ReactRailsUJS.useContext(componentRequireContext);



// WEBPACK FOOTER //
// ./app/javascript/packs/ui.js